(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7922],{

/***/ 70592:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[slug]",
      function () {
        return __webpack_require__(94649);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23855);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42298);


var DateFormatter = function(param) {
    var dateString = param.dateString;
    var date = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__["default"])(dateString);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
        dateTime: dateString,
        children: (0,date_fns__WEBPACK_IMPORTED_MODULE_2__["default"])(date, "LLLL	d, yyyy")
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DateFormatter);


/***/ }),

/***/ 94649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Post; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/posts/post-body.tsx

var PostBody = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-primary",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: content
            }
        })
    });
};
/* harmony default export */ var post_body = (PostBody);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/common/Footer.tsx
var Footer = __webpack_require__(26123);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/posts/date-formatter.tsx
var date_formatter = __webpack_require__(66025);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./pages/posts/[slug].tsx








var __N_SSG = true;
function Post(param) {
    var post = param.post, morePosts = param.morePosts;
    var router = (0,next_router.useRouter)();
    if (!router.isFallback && !(post === null || post === void 0 ? void 0 : post.slug)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "404"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: post && post.title + "| QMe - Hospital & Clinic Management"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: post.excerpt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.qme.co.in/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "/og.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Effortless Patient Management & Token-Based Appointments | QME"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "Experience efficient stock control, innovative token-based scheduling, and smart queues for unparalleled patient experiences at QME. Read for more!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "/og.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "index, follow"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "Organization",
                                "name": "QMe - Hospital and Clinic Management",
                                "image": "https://www.qme.co.in/logo.svg",
                                "description": "Effortless patient management, efficient stock and inventory control, unparalleled patient experience through innovative token-based appointments and smart queues and much more.",
                                "url": "https://www.qme.co.in/",
                                "telephone": "+919971513514",
                                "emailid": "contact@qme.co.in",
                                "sameAs": [
                                    "https://www.facebook.com/qmehmis",
                                    "https://www.instagram.com/qmehmis",
                                    "https://www.youtube.com/@qmehmis"
                                ]
                            }, null, "	")
                        }
                    }, "schema-jsonld")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white blogs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: router.isFallback ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: "Loading…"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col col-12 col-lg-10 offset-lg-1 card",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col col-12 col-lg-3 my-5 d-none d-lg-block bg-lightGrey m-lg-5 overflow-scroll",
                                        style: {
                                            maxHeight: "2000px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "ml-3 mt-3 fw-bold fs-5",
                                                children: "Similar Topics"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: morePosts.map(function(ms) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "text-primary mr-3 text-decoration-none my-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            as: "/posts/".concat(ms.slug),
                                                            href: "/posts/[ms.slug]",
                                                            target: "_blank",
                                                            className: "",
                                                            children: ms.title
                                                        })
                                                    }, ms.slug);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col col-12 col-lg-8 my-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "text-primary fw-bold",
                                                children: post && post.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-5 text-secondary",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(date_formatter/* default */.Z, {
                                                    dateString: post === null || post === void 0 ? void 0 : post.date
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(post_body, {
                                                content: post && post.contentHtml
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col col-12 col-lg-3 my-5 d-lg-none bg-lightGrey m-lg-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "ml-3 mt-3 fw-bold fs-5",
                                                children: "Similar Topics"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: morePosts.map(function(ms) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "text-primary mr-3 text-decoration-none my-3 content",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            as: "/posts/".concat(ms.slug),
                                                            href: "/posts/[ms.slug]",
                                                            target: "_blank",
                                                            className: "",
                                                            children: ms.title
                                                        })
                                                    }, ms.slug);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,7847,4035,1074,6123,9774,2888,179], function() { return __webpack_exec__(70592); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);